import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import HelpPopup from '@base/lib/HelpPopup';
import { Button } from '@base/lib/Button';
import Iconfont from '@base/lib/Iconfont';
import { useStoreState } from 'base/store'

type IProps = {
    className?: string;
};

export const ProdVat: FC<IProps> = ({ className }) => {
    const { t } = useTrans();

    const { country } = useStoreState('rootStore');
    
    return (
        <HelpPopup
            trigger={
                <Button
                    className={className}
                    type={'no-style'}
                    icon={<Iconfont className={'icon-help'}/>}
                />
            }
            content={
                <div className={'text-center'}>
                    {t(country == 'AU'
                        ? 'web_shop_product_price_gst_tips'
                        : 'web_shop_product_price_vat_tips'
                    )}
                </div>
            }
        />
    )
};
